import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import { MenuItem } from '../../common/MenuItem/MenuItem'
import useAuthStore from '../../../stores/useAuthStore/useAuthStore'
import { useApi } from '../../../hooks/useApi/useApi'
import { logoutCleanup } from '../../../utils/logoutCleanup'
import useNavigationGuardStore from '@/stores/useNavigationGuardStore/useNavigationGuardStore'

export const UserMenu: React.FC = () => {
    const { t } = useTranslation('translations')
    const navigate = useNavigate()

    const sessionId = useAuthStore((state) => state.sessionId)

    const { useLogoutMutation } = useApi()
    const { mutate: logout } = useLogoutMutation()

    const performLogoutCleanupAndNavigate = () => {
        logoutCleanup()
        void navigate({ to: '/login' })
    }

    const handleLogout = () => {
        const {
            hasUnsavedChanges,
            onNavigationBlocked,
            setOnNavigationConfirmHandler,
        } = useNavigationGuardStore.getState()

        if (!sessionId) {
            // If no sessionId, just clean up locally
            performLogoutCleanupAndNavigate()
            return
        }

        if (hasUnsavedChanges) {
            setOnNavigationConfirmHandler(() => {
                logout(sessionId, {
                    onSuccess: performLogoutCleanupAndNavigate,
                    onError: performLogoutCleanupAndNavigate,
                })
            })

            if (onNavigationBlocked) {
                onNavigationBlocked()
            }

            return
        }

        logout(sessionId, {
            onSuccess: performLogoutCleanupAndNavigate,
            onError: performLogoutCleanupAndNavigate,
        })
    }

    return (
        <>
            <MenuItem
                path="/"
                variant="ghost"
                label={t('user_menu.logout')}
                icon="logout"
                iconPosition="end"
                iconSize="small"
                render={({ renderContents }) => (
                    <button
                        className="w-full"
                        onClick={handleLogout}
                        data-testid="log-out-button"
                    >
                        {renderContents()}
                    </button>
                )}
            />
        </>
    )
}
